import { renderDeadline } from '../common/renderDeadline';
import { renderKnmErknmStatus } from '../common/renderKnmErknmStatus';
import { renderReasonTypes } from '../common/renderReasonTypes';
import { IPublishRulesHistoryField } from '../interfaces/IPublishRulesHistoryField';

export const publishRulesHistoryFieldsDate: Record<string, IPublishRulesHistoryField> = {
  '/settings/mainRule/publicationMode': {
    name: 'Дата публикации',
    active: true,
  },
  '/settings/mainRule/passportStatusCodes/{id}': {
    name: 'По достижению статуса',
    active: true,
    renderFunc: renderKnmErknmStatus,
  },
  '/settings/additionalRules/{id}/reasonTypeId': {
    name: 'Тип основания',
    active: true,
    renderFunc: renderReasonTypes,
  },
  '/settings/additionalRules/{id}/rule/passportStatusCodes/{id}': {
    name: 'По достижению статуса',
    active: true,
    renderFunc: renderKnmErknmStatus,
  },
  '/settings/additionalRules/{id}/rule/publicationMode': {
    name: 'Дата публикации',
    active: true,
  },
};

export const publishRulesHistoryFieldsDeadline: Record<string, IPublishRulesHistoryField> = {
  ...publishRulesHistoryFieldsDate,
  '/settings/mainRule/publicationMode': {
    name: 'Срок публикации',
    active: true,
    renderFunc: renderDeadline,
  },
  '/settings/additionalRules/{id}/rule/publicationMode': {
    name: 'Срок публикации',
    active: true,
    renderFunc: renderDeadline,
  },
};
